import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"school, building"} maskId="square-filled-radius-0-stroke-1-IconSchool"><path fillRule="evenodd" clipRule="evenodd" d="M6 4H18V19H19V8H22V19H23V20H1V19H2V8H5V19H6V4ZM14 19V16H10V19H14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSchool;
